<header class="step-head breadcrumbs">
  <div class="wrapper">
    <div class="sas-logo">
      <a class="icon-logo" id="buywifi_saslogo" href="javascript:void(0);" (click)="goToBreadcrumb(0);" tabindex="0" title="Graphic SAS logo Scandinavian Airlines press enter to  go back to homepage"></a>
    </div>
    <nav class="booking-steps">
      <ul>
        <li *ngFor="let title of breadCrumbs; index as i">
          <a href="javascript:;" id="{{title.id}}" [ngClass]="{'disable-pointer':currentState===i,'active':currentState===i ,'inactive':currentState!==i && currentState !== 2,'disable' : i>currentState}" [attr.aria-label]="(currentState===i)?('currentlySelected' | translate)+ ' ' +(title.label | translate):(title.label | translate)" [attr.tabindex]="(title.active)?0:-1" (click)="(title.active && i<currentState)?goToBreadcrumb(i+1):'';">
            {{i+1 + ". " + (title.label | translate)}}</a>
        </li>
      </ul>
    </nav>
    <div class="mobile-booking-steps">
      <div *ngFor="let title of breadCrumbs; index as i">
        <div *ngIf="i === currentState">
            <a class="icon-arrow-left-white back" id="{{title.id}}" *ngIf="currentState !== 2" (click)="goToBreadcrumb(i);"></a>
            <span class="step-count font-12">{{i+1 + ' of ' + 3}}</span>
            <p class="step-title font-16">{{title.label | translate}}</p>
        </div>
      </div>
    </div>
  </div>
</header>
<div class="module-bg"></div>
